import React, { useCallback, useEffect, useState } from 'react';
import Input from '../../DesignSystem/input';
import { VerifyPopupMapping } from '../../../utils/appConstants';
import FormFieldBox from '../../DesignSystem/formFieldBox';
import Button from '../../DesignSystem/button';

export interface VerifyPopupProps {
    portId: string;
    positions_in_ne: any[];
    ne_available_port: number;
    ne_name: string;
    ne_management_ip: string;
    verified: boolean;
    verifyButton: (id: string, pos: number) => void;
    moveButton: (id: string, pos: number) => void;
    setVerifyPopupOpen: (t: boolean) => void;
    setVerifyLoadingId: (port: string) => void;
}

export const VerifyPopup: React.FC<VerifyPopupProps> = ({
  positions_in_ne, verifyButton, setVerifyPopupOpen, portId, setVerifyLoadingId, verified, moveButton, ne_available_port, ne_name, ne_management_ip,
}) => {
  const [invalidPositionError, setInvalidPositionError] = useState<number>(0);
  const [enteredPosition, setEnteredPosition] = useState<number>(0);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [showPortsOnSwitchPage, setShowPortsOnSwitchPage] = useState<boolean>(false);
  const [allPortsJSX, setAllPortsJSX] = useState<any>('');

  const checkPositionValid: (enterPos: number) => boolean = (enterPos: number): any => {
    if (enterPos == 0) {
      return true;
    }
    let valid = false;
    positions_in_ne.forEach((position:number) => {
      if (position == enterPos) {
        valid = true;
      }
    });
    return valid;
  };

  const handleInputChange = useCallback((e:any) => {
    const value = e?.target?.value ?? 0;
    setEnteredPosition(value);
  }, [setEnteredPosition]);

  const verifyButtonClick = useCallback(() => {
    setButtonLoading(true);
    if (checkPositionValid(enteredPosition)) {
      setInvalidPositionError(0);
      setVerifyPopupOpen(false);
      if (enteredPosition > 0) {
        verifyButton(portId, enteredPosition);
      } else {
        verifyButton(portId, 0);
      }
      setButtonLoading(false);
      setEnteredPosition(0);
    } else {
      setInvalidPositionError(enteredPosition);
      setButtonLoading(false);
    }
  }, [setButtonLoading, enteredPosition, setInvalidPositionError, setVerifyPopupOpen, setEnteredPosition]);

  const moveButtonClick = useCallback(() => {
    setButtonLoading(true);
    if (checkPositionValid(enteredPosition)) {
      setInvalidPositionError(0);
      setVerifyPopupOpen(false);
      if (enteredPosition > 0) {
        moveButton(portId, enteredPosition);
      } else {
        moveButton(portId, 0);
      }
      setButtonLoading(false);
      setEnteredPosition(0);
    } else {
      setInvalidPositionError(enteredPosition);
      setButtonLoading(false);
    }
  }, [setButtonLoading, enteredPosition, setInvalidPositionError, setVerifyPopupOpen, setEnteredPosition]);

  const closeVerifyPopup = useCallback(() => {
    setVerifyPopupOpen(false);
    setInvalidPositionError(0);
    setButtonLoading(false);
    setEnteredPosition(0);
    setVerifyLoadingId('');
  }, [setInvalidPositionError, setButtonLoading, setEnteredPosition]);

  const showAllPortsClick = useCallback(() => {
    setShowPortsOnSwitchPage(true);
  }, []);

  const hideAllPortsOnSwitch = useCallback(() => {
    setShowPortsOnSwitchPage(false);
    setAllPortsJSX('');
  }, []);

  useEffect(() => {
    let allPortsTemp = '';
    positions_in_ne.forEach((position: number) => {
      allPortsTemp += `[${position}] `;
    });
    setAllPortsJSX(allPortsTemp);
  }, [showPortsOnSwitchPage]);

  return (
    <div className="verify-popup-root">
      {(!showPortsOnSwitchPage) ? (
        <div className="verify-popup">

          <FormFieldBox>
            <h1>{ne_name}</h1>
            {(ne_management_ip) ? (
              <label><a href={ne_management_ip} target={ne_management_ip}>Link to Switch</a></label>
            ) : (
              null
            )}
            <br />
            {(!verified) ? (
              <label>
                Enter Position on Switch:
              </label>
            ) : (
              <label>
                Enter Position to Move To:
              </label>
            )}
            <h4>{`${positions_in_ne.length}/${ne_available_port} ports remaining`}</h4>
            <Input placeholder="Position" variant="number" name={VerifyPopupMapping.position} onChange={(e) => handleInputChange(e)} error={invalidPositionError > 0} />
            {invalidPositionError > 0 && <span>{`Position ${invalidPositionError} is not available`}</span>}
            <br />
            {(!verified) ? (
              <Button variant="success" node={enteredPosition > 0 ? `Verify at position ${enteredPosition}` : 'Verify at next available position'} onClick={verifyButtonClick} loading={buttonLoading} />
            ) : (
              <Button variant="success" node={enteredPosition > 0 ? `Move to position ${enteredPosition}` : 'Move to next available position'} onClick={moveButtonClick} loading={buttonLoading} />
            )}
            <br />
            <Button variant="search" node="See all available ports" onClick={showAllPortsClick} />
            <br />
            <Button variant="close" node="Close" onClick={closeVerifyPopup} />
          </FormFieldBox>
        </div>
      ) : (
        <div className="show-all-page">
          {allPortsJSX}
          <br />
          <Button variant="close" node="Close" onClick={hideAllPortsOnSwitch} />
        </div>
      )}

    </div>
  );
};
